import { Component, OnInit, Injector, Input } from '@angular/core';
import { FileRestrictions, SelectEvent, ClearEvent, RemoveEvent, FileInfo } from '@progress/kendo-angular-upload';
import { S3Service } from '../../../../../../shared/services/s3.service';
import { PartService, AttachmentService } from "../../../../phf.service";
import { PartDetailService } from '../part-detail.service';


@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})

export class FileUploadComponent implements OnInit {
  // body for an item(Part, Container...etc)
  @Input() item: string;
  @Input() info: any;

  private
  public events: string[] = [];
  public imagePreviews: FileInfo[] = [];
  public uploadRestrictions: FileRestrictions = {
    allowedExtensions: ['.jpg', '.png', '.gif']
  };
  private readonly s3Service: S3Service;
  private readonly partService: PartService;
  private readonly attachmentService: AttachmentService;
  private readonly messageService: PartDetailService;

  private clickImg = false;


  constructor(private readonly injector: Injector
  ) {
    this.s3Service = injector.get(S3Service);
    this.partService = injector.get(PartService);
    this.attachmentService = injector.get(AttachmentService);
    this.messageService = injector.get(PartDetailService);
  }

  ngOnInit() {
    switch (this.item.toLowerCase()) {
      case "part":
        this.getPartImage();
        break;
      case "container":
        this.getContainerImage();
        break;
      default:
        break;
    }
  }

  private getPartImage() {
    const part = this.info;
    if (part.Attachment) {
      this.partService.read('/' + part.Id).then(dataItem => {
        this.attachmentService.read('/' + dataItem.AttachmentId)
          .then(response => {
            if (response) {
              const filePath = 'PHF/PartPictures/' + response.FileName;
              response.src = this.s3Service.getS3Path(filePath);
              this.imagePreviews.unshift(response);
            }
          });
      })
    }
  }

  private getContainerImage() {
    const container = this.info;
    if (container.AttachmentId) {
      this.attachmentService.read('/' + container.AttachmentId)
        .then(response => {
          if (response) {
            const filePath = 'PHF/ContainerPictures/' + response.FileName;
            response.src = this.s3Service.getS3Path(filePath)
            this.imagePreviews.unshift(response);
          }
        });
    }
  }

  public clearEventHandler(e: ClearEvent): void {
    this.log('Clearing the file upload');
    this.imagePreviews = []
  }

  public completeEventHandler(e: any) {
    this.log(`All files processed`);
  }

  public removeEventHandler(e: RemoveEvent): void {
    this.log(`Removing ${e.files[0].name}`);

    const index = this.imagePreviews.findIndex(item => item.uid === e.files[0].uid);

    if (index >= 0) {
      this.imagePreviews.splice(index, 1);
    }
  }

  readonly selectEventHandler = (e: SelectEvent): void => {

    e.files.forEach((file) => {
      this.log(`File selected: ${file.name}`);

      if (!file.validationErrors) {
        const reader = new FileReader();

        reader.onload = (ev) => {
          const image = {
            src: (ev.target as FileReader).result,
            uid: file.uid,
            name: file.name,
            state: file.state,
            rawFile: file.rawFile,
          };

          this.imagePreviews.unshift(image);
        };

        reader.readAsDataURL(file.rawFile);

        if (this.item.toLowerCase() === "container") {
          this.messageService.containerDataObject.get('AttachmentFileInfo').setValue(this.imagePreviews);
        }
        if (this.item.toLowerCase() === 'part') {
          this.messageService.partDetailHeaderDataObject.get('AttachmentFileInfo').setValue(this.imagePreviews);
        }
      }
    });
  }

  private log(event: string): void {
    this.events.unshift(`${event}`);
  }

  public isFileUploaded() {
    if (this.imagePreviews.length > 0 && this.imagePreviews[0].state === 3) {
      return true;
    } else {
      return false;
    }
  }

  getButtonCaption = () => {
    return this.isFileUploaded() ? 'File Uploaded!' : 'Upload';
  }

  uploadEventHandler(...opts) { }

  isImgOpen = () => {
    return this.clickImg;
  }

  openImg() {
    this.clickImg = true;
  }

  closeImg() {
    this.clickImg = false;
  }

  getImageModalTitle() {
    if (this.item === 'part') {
      return this.info.Code;
    }
    else {
      return 'test';
    }
  }
}
